/* eslint-disable no-unused-vars */
import API from "./API";
import { AgentUtils } from "./AgentUtils";
import axios from "axios";
import db from "../db/db";

export const PoleDisplayUtils = {
  showOnPole,
  prepareValue,
};

async function showOnPole(terminalBean, line1, line2) {
  let url = "";
  let token = "";
  if (
    terminalBean.printingMode === "CLOUD_PRINT" &&
    terminalBean.poleDisplayPort
  ) {
    if (localStorage.getItem("w_cloud_print_token")) {
      token = localStorage.getItem("w_cloud_print_token");
      url = localStorage.getItem("w_cloud_print_url");
    } else {
      [url, token] = await getCloudPrintToken();
      localStorage.setItem("w_cloud_print_token", token);
      localStorage.setItem("w_cloud_print_url", url);
    }
    let payload = { line1: line1, line2: line2 };
    try {
      try {
        await sendPoleDisplayRequestToServer(
          url,
          token,
          terminalBean.poleDisplayPort,
          payload
        );
      } catch (e) {
        [url, token] = await getCloudPrintToken();
        localStorage.setItem("w_cloud_print_token", token);
        localStorage.setItem("w_cloud_print_url", url);
        await sendPoleDisplayRequestToServer(
          url,
          token,
          terminalBean.poleDisplayPort,
          payload
        );
      }
    } catch (err) {
      console.log(err);
    }
  }
  if (terminalBean.printingMode === "LOCAL" && terminalBean.poleDisplayPort) {
    let payload = { line1: line1, line2: line2 };
    try {
      sendPoleDisplayRequestToAgent(terminalBean.poleDisplayPort, payload);
    } catch (e) {}
  }
}

async function sendPoleDisplayRequestToServer(url, token, printerId, payload) {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  await axios.post(
    url + "/cloudprintbackend/api/v1/core/device/" + printerId + "/showonpole",
    payload,
    config
  );
}

async function sendPoleDisplayRequestToAgent(port, payload) {
  payload["port"] = port;
  try {
    let response = await axios.post(
      "http://localhost:3337/agent/device/showonpole",
      payload
    );
    return response;
  } catch (err) {
    console.log(err);
  }
}

async function getCloudPrintToken() {
  let sValue = await db.setting
    .where("sKey")
    .equals("store_cloud_print")
    .toArray();

  let cloudpRingConfig = JSON.parse(sValue[0].svalue);
  let url = cloudpRingConfig.cloudPrinterUrl;
  let apiKey = cloudpRingConfig.cloudPrinterApiKey;

  let { data } = await axios.post(
    url + "/cloudprintbackend/api/v1/auth/signin_with_apikey",
    {
      securityKey: apiKey,
    }
  );
  return [url, data.accessToken];
}

function prepareValue(value1, value2) {
  try {
    if ((value1 + " " + value2).length > 20) {
      let maxLength = 20 - (" " + value2).length;
      value1 = value1.substring(0, maxLength);
    }
    //console.log(value1 + "#" + value2);
    let len = value1.length;
    return value1 + value2.padStart(20 - len, " ");
  } catch (err) {
    return value1 + (value2 ? value2 : "").padStart;
  }
}
